/// <amd-module name="DistributedTaskUI/Resources/Constants" />
export const enum ViewType {
    "Hub" = 1,
    "ServiceEndpoint" = 2,
    "SecurityTab" = 3
}

export const EndpointsEditorTypesViewType = "ServiceEndpointTypes";
export const CheckIssuesDataProviderContribution: string = "ms.vss-pipelinechecks.checks-issues-provider";